import { c as _c } from "react/compiler-runtime";
import { Plus } from 'lucide-react';
import { useTranslations } from 'next-intl';
import ViverseButton from '@/components/ViverseButton';
type NoMediaProps = {
  onStartEditing: () => void;
};
export default function NoMedia(t0) {
  const $ = _c(13);
  const {
    onStartEditing
  } = t0;
  const t = useTranslations();
  let t1;
  if ($[0] !== t) {
    t1 = t("profile-page.photos-videos-no-media");
    $[0] = t;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== t1) {
    t2 = <p className="body text-base">{t1}</p>;
    $[2] = t1;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <Plus className="stroke-vive-primary-20 mr-2 size-6" />;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  let t4;
  if ($[5] !== t) {
    t4 = t("profile-page.add-media");
    $[5] = t;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  let t5;
  if ($[7] !== onStartEditing || $[8] !== t4) {
    t5 = <ViverseButton variant="icon3" className="group" onClick={onStartEditing}>{t3}{t4}</ViverseButton>;
    $[7] = onStartEditing;
    $[8] = t4;
    $[9] = t5;
  } else {
    t5 = $[9];
  }
  let t6;
  if ($[10] !== t2 || $[11] !== t5) {
    t6 = <div className="flex min-h-[269px] flex-col items-center justify-center gap-5">{t2}{t5}</div>;
    $[10] = t2;
    $[11] = t5;
    $[12] = t6;
  } else {
    t6 = $[12];
  }
  return t6;
}